export function initDrawOut() {
    // Function to trigger the animation
    const pathsToDraw = document.querySelectorAll('.draw-out');
    for (const pathToDraw of pathsToDraw) {
        // Get the path length and set it in CSS
        const pathLength = pathToDraw.getTotalLength();
        pathToDraw.style.strokeDasharray = pathLength;
        pathToDraw.style.strokeDashoffset = pathLength;
        pathToDraw.classList.add('animate-path'); // Trigger animation
    }
}